import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useParams, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import CourtScan from "./pages/CourtScan";
import Customiser from "./pages/Customiser";
import Quote from "./pages/Quote";
import ThankYou from "./pages/ThankYou";
import Gallery from "./pages/Gallery";
import ProjectDetail from "./pages/ProjectDetail";
import Founders from "./pages/About";
import ServicesIndex from "./pages/ServicesIndex";
import ServiceDetail from "./pages/ServiceDetail";
import MethodIndex from "./pages/MethodIndex";
import MethodDetail from "./pages/MethodDetail";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Assessment from "./pages/Assessment";
import Compliance from "./pages/Compliance";
import Showcase from "./pages/Showcase";
import ShowcaseMobile from "./pages/ShowcaseMobile";
import Portfolio from "./pages/Portfolio";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Terms from "./pages/Terms";
import Links from "./pages/Links";
import BrandKit from "./pages/BrandKit";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import ProtectedRoute from "./pages/admin/ProtectedRoute";
import { captureAttribution } from "./lib/attribution";
import { trackPageView } from "./lib/gtag";

captureAttribution();

const PageViews = () => {
  const loc = useLocation();
  useEffect(() => {
    const t = setTimeout(() => trackPageView(loc.pathname + loc.search), 150);
    return () => clearTimeout(t);
  }, [loc.pathname, loc.search]);
  return null;
};

const BlogRedirect = () => {
  const { slug } = useParams();
  return <Navigate to={`/blog-articles/${slug}`} replace />;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <PageViews />
          <Toaster theme="dark" position="top-center" richColors />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/court-scan" element={<CourtScan />} />
              <Route path="/customiser" element={<Customiser />} />
              <Route path="/quote" element={<Quote />} />
              <Route path="/thank-you" element={<ThankYou />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/gallery/:id" element={<ProjectDetail />} />
              <Route path="/about" element={<Founders />} />
              <Route path="/brand-kit" element={<BrandKit />} />
              <Route path="/founders" element={<Navigate to="/about" replace />} />
              <Route path="/services" element={<ServicesIndex />} />
              <Route path="/services/:slug" element={<ServiceDetail />} />
              <Route path="/method" element={<MethodIndex />} />
              <Route path="/method/:slug" element={<MethodDetail />} />
              <Route path="/blog-articles" element={<Blog />} />
              <Route path="/blog-articles/:slug" element={<BlogPost />} />
              <Route path="/blog" element={<Navigate to="/blog-articles" replace />} />
              <Route path="/blog/:slug" element={<BlogRedirect />} />
              <Route path="/assessment" element={<Assessment />} />
              <Route path="/compliance" element={<Compliance />} />
              <Route path="/sydney-court-resurfacing-guides" element={<Showcase />} />
              <Route path="/sydney-court-resurfacing-mobile" element={<ShowcaseMobile />} />
              <Route path="/sydney-court-resurfacing-portfolio" element={<Portfolio />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms" element={<Terms />} />
            </Route>
            <Route path="/links" element={<Links />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
